import { createApi } from "@reduxjs/toolkit/query/react"
import { authQuery } from "./authQuery"
import { GraphApproval, GraphApprovalStatus } from "@custom-types/graphs"
import { PaginatedRequestParameters, PaginatedResponse } from "@custom-types/utils"
import { parsePaginationParams } from "@utils/http"

export const approvalsApi = createApi({
  reducerPath: "approvalsApi",
  baseQuery: authQuery,
  tagTypes: ["approvals"],
  endpoints: (builder) => ({
    getApprovals: builder.query<
      PaginatedResponse<GraphApproval>,
      PaginatedRequestParameters<{ status?: GraphApprovalStatus }>
    >({
      query: (params) => {
        const parsedParams = parsePaginationParams(params)

        return { url: `/approvals`, params: parsedParams }
      },
      providesTags: ["approvals"],
    }),
    getApproval: builder.query<GraphApproval, string>({
      query: (approvalKey) => ({ url: `/approval/${approvalKey}` }),
      providesTags: (response) => [{ type: "approvals", id: response?.key }],
    }),
    publishMajorGraphVersion: builder.mutation<unknown, { graphKey: string; runGroupKey: string }>({
      query: (params) => ({
        url: `/approvals/${encodeURIComponent(params.graphKey)}/publish_major?run_group_key=${
          params.runGroupKey
        }`,
        method: "POST",
      }),
      invalidatesTags: ["approvals"],
    }),
    patchApproval: builder.mutation<unknown, { key: string; payload: Partial<GraphApproval> }>({
      query: ({ key, payload }) => ({
        url: `/approval/${key}`,
        method: "PATCH",
        body: payload,
      }),
      invalidatesTags: ["approvals"],
    }),
  }),
})

export const {
  useGetApprovalsQuery,
  usePublishMajorGraphVersionMutation,
  useGetApprovalQuery,
  usePatchApprovalMutation,
} = approvalsApi
